/**
 * Italian catalog (Latin) for the Phase 2 `MessageId` set — Agent 9, batch 2.
 *
 * `dir: 'ltr'`. Native-grade Italian at a mathematician's register. **Warrant → «Garanzia»**
 * (Toulmin). W/M grades stay Latin (`::numbering-system/latn`). CLDR cardinal categories are
 * one / many / other (`many` = the large compact-number form), so `frameActive` declares
 * exactly those (plus an explicit `=0`). Per INV-STABLE-ID a wrong translation is a
 * presentation concern only — every verdict stays fixed.
 */
import { P2 } from '../message-ids-phase2.js';
export const IT_CATALOG = {
    locale: 'it',
    dir: 'ltr',
    messages: {
        [P2.inquiryTitle]: 'Indagine',
        [P2.sectionClaims]: 'Affermazioni',
        [P2.sectionIntegrity]: 'Integrità',
        [P2.axisWarrantLabel]: 'Garanzia',
        [P2.axisWarrantValue]: 'W{w, number, ::numbering-system/latn}',
        [P2.axisEmpiricalLabel]: 'Empirico',
        [P2.axisEmpiricalValue]: '{kind, select, defn {Definizione} interp {Interpretazione} testable {Testabile} tested {Testato} refuted {Confutato} program {Programma di ricerca} philos {Filosofico} other {Sconosciuto}}',
        [P2.axisModalLabel]: 'Modale',
        [P2.axisModalValue]: 'M{m, number, ::numbering-system/latn}',
        [P2.axisKidSummary]: 'Livello di forza {w, number, ::numbering-system/latn}',
        [P2.stateExplorable]: 'Esplorabile',
        [P2.stateRefuted]: 'Confutato',
        [P2.stateOutside]: 'Fuori ambito',
        [P2.verdictConflict]: 'In conflitto con {constraints}',
        [P2.verdictOutside]: 'Richiede {missing}',
        [P2.lossRegisterPlain]: 'Semplificato in linguaggio comune — parte della precisione è omessa.',
        [P2.lossRegisterKid]: 'Semplificato per i lettori più giovani — molti dettagli sono omessi.',
        [P2.lossProfileDetail]: 'Il profilo completo Garanzia / Empirico / Modale è riassunto qui.',
        [P2.lossConflictDetail]: 'I dettagli del conflitto sono abbreviati in questa vista.',
        [P2.laneVerified]: 'Verificato',
        [P2.laneUnverified]: 'Non verificato',
        [P2.laneConflict]: 'Conflitto dimostrato',
        [P2.constraintLogic]: 'Logica',
        [P2.constraintLightBends]: 'La luce si curva in un campo gravitazionale',
        [P2.constraintParallelPostulate]: 'Il postulato delle parallele',
        [P2.claimScalarGravity]: 'Teoria scalare della gravità',
        [P2.claimNonEuclidean]: 'Geometria non euclidea',
        [P2.claimSubstrateSr]: 'Interpretazione a substrato della relatività ristretta',
        [P2.edgeExtObservation]: 'Osservazione esterna',
        [P2.edgeResourceSample]: 'Risorsa di calcolo condivisa',
        [P2.edgeHeuristicSample]: 'Guida euristica',
        [P2.edgeSharedSample]: 'Fondamento condiviso',
        // --- Phase 2 view-chrome ---
        [P2.sectionConstraints]: 'Vincoli',
        [P2.sectionEdges]: 'Archi',
        [P2.sectionFrame]: 'Quadro',
        [P2.sectionExposure]: 'Esposizione',
        [P2.statusAdoptedFormal]: 'Adottato (formale)',
        [P2.statusAdoptedInterpretive]: 'Adottato (interpretativo)',
        [P2.statusSuspended]: 'Sospeso',
        [P2.edgeEffectConstraint]: 'Compone un vincolo (può confutare)',
        [P2.edgeEffectResource]: 'Risorsa — nessun effetto sui verdetti',
        [P2.edgeEffectHeuristic]: 'Euristica — nessun effetto sui verdetti',
        [P2.edgeEffectShared]: 'Fondamento condiviso — nessun effetto sui verdetti',
        [P2.frameActive]: '{count, plural, =0 {Nessun vincolo attivo} one {# vincolo attivo} many {# vincoli attivi} other {# vincoli attivi}}',
        [P2.exposureNone]: 'Nessuna dipendenza interpretativa',
        [P2.exposureDep]: 'Dipende da {id}',
        [P2.laneTrackMachine]: 'Macchina',
        [P2.laneTrackExpert]: 'Esperto',
        [P2.laneTrackCommunity]: 'Comunità',
        [P2.expertAudited]: 'Sottoposto ad audit',
        [P2.expertInProgress]: 'In corso',
        [P2.expertNotReviewed]: 'Non esaminato',
        [P2.communityFlags]: 'Segnalazioni presenti',
        [P2.communityNone]: 'Nessuna segnalazione',
        [P2.controlChallenge]: 'Contestare',
        [P2.controlActivate]: 'Attivare',
        [P2.controlMakeInterpretive]: 'Rendere interpretativo',
        [P2.controlImportEdge]: 'Importa arco',
        [P2.controlPromote]: 'Promuovere',
        [P2.controlUndo]: 'Annulla',
        [P2.controlRedo]: 'Ripeti',
        [P2.controlRegister]: 'Registra',
        [P2.promoteRejected]: 'Promozione respinta',
        [P2.promoteAccepted]: 'Promozione accettata',
        [P2.promoteReasonRefutationTerminal]: 'Una dimostrazione non può sanare una confutazione.',
        [P2.promoteReasonKeystone]: 'Una promozione chiave di volta richiede supporto empirico.',
        [P2.promoteReasonEmpiricalNotFixed]: 'Il tipo empirico non è fissato.',
        [P2.promoteReasonModalNotFixed]: 'Il grado modale non è fissato.',
        [P2.promoteReasonWarrantNotImproved]: 'Il grado di garanzia non è migliorato.',
        [P2.evidenceComputation]: "{engine} ha calcolato {op} = {result} con {config}",
        [P2.lossNumericRounding]: "Risultato arrotondato a {dp} decimali",
    },
};
//# sourceMappingURL=it.js.map